import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
    const isAuthenticated = !!localStorage.getItem('token');
    const userRole = localStorage.getItem('roleId') ? parseInt(localStorage.getItem('roleId')) : 0;

    // Si no está autenticado, redirigir al login
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // Si no hay roles especificados, permitir acceso (para rutas públicas autenticadas)
    if (allowedRoles.length === 0) {
        return children;
    }

    // Verificar si el rol del usuario está en los roles permitidos
    if (allowedRoles.includes(userRole)) {
        return children;
    }

    // Si no tiene permisos, redirigir al home
    return <Navigate to="/" />;
};

export default RoleBasedRoute;